import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrianglesDotsHorizontalCollapse = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1759_9258)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M8.25 0.750001L8.24999 0H3.75V0.749999L5.99999 3L8.25 0.750001Z",
				fill: "black",
				fillOpacity: .6
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.75 11.25L3.75001 12L8.25 12V11.25L6.00001 9L3.75 11.25Z",
				fill: "black",
				fillOpacity: .6
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.75 5.25H2.25V6.75H0.75V5.25Z",
				fill: "black",
				fillOpacity: .6
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.75 5.25H5.25V6.75H3.75V5.25Z",
				fill: "black",
				fillOpacity: .6
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.75 5.25H8.25V6.75H6.75V5.25Z",
				fill: "black",
				fillOpacity: .6
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.25 5.25H9.75V6.75H11.25V5.25Z",
				fill: "black",
				fillOpacity: .6
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1759_9258",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 12,
			height: 12,
			fill: "white"
		})
	}) })]
});
export default SvgTrianglesDotsHorizontalCollapse;
